import React                from 'react';
import Grid2                from '../Grid2/Grid2';
import InterviewTile        from '../Grid2/Tiles/Interview/InterviewTile';
import {ModelInterviewType} from "../Grid2/Tiles/Interview/InterviewTilePropTypes";
import withActorInterviews  from "../Profile/withActorInterviews";
import Translations         from "../../utils/Translations";
import PropTypes            from 'prop-types';

const ProfileInterviewsBlock = (props) => {
	if (!Array.isArray(props.interviews) || props.interviews.length === 0) {
		return null;
	}

	return (
		<div className="media-panel container-block -margin-bottom-lg">
			<div className="context-box--actor-profile clearfix">
				<h3 className="context-box__title h-left" dangerouslySetInnerHTML={{__html: Translations.get('MediaPanelActorInterviews')}}></h3>
			</div>
			<div id="actor-interview-container">
				<Grid2 tileData={props.interviews}
				       defaultTileClass={InterviewTile}
				       columns={props.interviews.length}
				/>
			</div>
		</div>
	);
};

ProfileInterviewsBlock.propTypes = {
	interviews: PropTypes.arrayOf(ModelInterviewType.isRequired),
};

export default withActorInterviews(ProfileInterviewsBlock);